import router from "@/router";
import { apiUrl, axiosAuthGet, errorHandling } from './utils';

export class BuildingService {
    async getBuildingName() {
        let buildingId = router.currentRoute.value.params.building;
        let url = apiUrl + 'building/name/' + buildingId;
        let results = axiosAuthGet(url)
            // .catch((err) => {
            //     errorHandling(err)
            // })
        return results;
    }
}